import React, { useEffect, useState } from "react";
import CardHeadMenu from "../Card/CardHeadMenu/CardHeadMenu";
import PrescriptionTable from "./PrescriptionTable";
import { motion } from "framer-motion";
import CustomerDetails from "../Card/Diagnosis/CustomerDetails";
import Button from "@mui/material/Button";
import {
  Box,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Grid,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import configServ from "../../services/config";
import PrescriptionDetails from "./PrescriptionDetails";
import PrescriptionDetailsCustomer from "./PrescriptionDetailsCustomer";
import CircularProgress from "@mui/material/CircularProgress";
import ReportSection from "./ReportSection";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const Prescriptions = () => {
  //#region code
  const [isChanged, setIsChanged] = useState(false);
  const [editData, setEditData] = useState(null);
  const [diagnosisData, setDiagnosisData] = useState([]);

  const [isCreate, setIsCreate] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [loadingg, setLoadingg] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [responses, setResponses] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);

  const [items, setItems] = useState([]);
  const [selectedPainArea, setSelectedPainArea] = useState(null);

  const [prescriptions, setPrescriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleUserSelect = (userId) => {
    setSelectedUserId(userId);
    // console.log("Selected User ID:", userId);
  };

  const handlePopup = () => {
    try {
      if (isCreate === true) {
      }
      setIsCreate(!isCreate);
      resetReports();
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCustomerItems = async () => {
    try {
      setLoadingg(true);
      const dataToSend = {
        customer_id: selectedUserId,
      };
      const res = await configServ.getActiveDiagnosesItemsforCustomer(
        dataToSend
      );
      if (res.success) {
        setItems(res.data);
      } else {
        setItems([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingg(false);
    }
  };

  useEffect(() => {
    if (selectedUserId && isCreate) {
      fetchCustomerItems();
    }
  }, [selectedUserId, isCreate]);

  const fetchCustomerItemsQuestion = async () => {
    try {
      setIsLoading(true); // also fix the loading state usage
      const dataToSend = {
        customer_id: selectedUserId,
        item_id: selectedPainArea?.item_id,
      };
      const res = await configServ.getDiagnosisResponsesByCustomerAndItem(
        dataToSend
      );
      if (res.success) {
        setResponses(res.data);
      } else {
        setResponses([]);
      }
    } catch (error) {
      console.error("Error fetching responses:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selectedUserId && isCreate && selectedPainArea?.item_id) {
      fetchCustomerItemsQuestion();
    }
  }, [selectedUserId, isCreate, selectedPainArea?.item_id]); // <-- FIXED DEP

  useEffect(() => {
    if (selectedUserId) {
      setItems([]);
      setSelectedPainArea(null);
    }
  }, [selectedUserId]); // <-- FIXED DEP

  // useEffect(() => {
  //   if (isCreate) {
  //     setItems([])
  //     setSelectedPainArea(null)
  //     setSelectedUserId(null)
  //   }
  // }, [isCreate]);

  const resetReports = () => {
    setItems([]);
    setSelectedPainArea(null);
    setSelectedUserId(null);
  };

  const fetchAllPrescriptions = async () => {
    setLoading(true);
    setError(null);

    try {
      const res = await configServ.getAllPrescriptions();

      if (res?.status) {
        setPrescriptions(res.data);
      } else {
        setError("Failed to fetch prescriptions");
      }
    } catch (err) {
      console.error(err);
      setError("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllPrescriptions();
  }, []);

  const handleReset = () => {
    setIsCreate(false);
    setItems([]);
    setSelectedPainArea(null);
    setSelectedUserId(null);
    fetchAllPrescriptions();
  };

  //#endregion

  return (
    <>
      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"PRESCRIPTIONS"}
        handlePopup={handlePopup}
        // isEdit={isEdit}
        create={isCreate}
        showCreate={true}
      />

      {isCreate === true && (
        <>
          <motion.div
            style={{
              width: "100%",
              backgroundColor: "#e3f3fc",
              padding: 20,
              paddingLeft: 0,
              borderRadius: "10px",
              border: "none",
              margin: "10px",
            }}
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.1, delay: 0.1 }}
          >
            <Box
              sx={{ p: 2 }}
              style={{
                width: "100%",
              }}
            >
              <Typography
                variant="h5"
                gutterBottom
                align="center"
                color="primary"
              >
                Create Prescription
              </Typography>

              <CustomerDetails
                onUserSelect={handleUserSelect}
                // ref={prescriptionRef}
                diagnosisData={diagnosisData}
                loadingg={loadingg}
              />

              {/* Pain Area Dropdown */}
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Box mt={2} mb={3}>
                    <Typography variant="h6" gutterBottom>
                      Select Pain Area
                    </Typography>
                    <FormControl fullWidth>
                      <InputLabel id="pain-area-label">Pain Area</InputLabel>
                      <Select
                        labelId="pain-area-label"
                        value={selectedPainArea?.item_id || ""}
                        label="Pain Area"
                        sx={{ backgroundColor: "white" }}
                        onChange={(e) => {
                          const selectedId = e.target.value;
                          const selectedItem = items?.diagnosis?.find(
                            (item) => item.item_id === selectedId
                          );
                          setSelectedPainArea(selectedItem);
                        }}
                      >
                        {items?.diagnosis?.map((item) => (
                          <MenuItem key={item.item_id} value={item.item_id}>
                            {item.item_name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
              </Grid>

              <ReportSection
                userId={selectedUserId}
                itemId={selectedPainArea?.item_id}
              />

              <Typography variant="h6" gutterBottom>
                Questionnaires Response
              </Typography>

              {!selectedPainArea?.item_id || !selectedUserId ? (
                <Typography color="error" align="center" mt={2} mb={5}>
                  Please select pain area
                </Typography>
              ) : isLoading ? (
                <Box display="flex" justifyContent="center" mt={2} mb={5}>
                  <CircularProgress />
                </Box>
              ) : responses.length === 0 ? (
                <Typography color="text.secondary" align="center" mt={2} mb={5}>
                  No data found
                </Typography>
              ) : (
                <Accordion
                  expanded={isExpanded}
                  onChange={() => setIsExpanded(!isExpanded)}
                  sx={{
                    backgroundColor: "white",
                    mt: 2,

                    width: isExpanded
                      ? "100%"
                      : { xs: "100%", sm: "100%", md: "50%" },
                    boxShadow: 1,
                    borderRadius: 2,
                    transition: "width 0.3s ease",
                    mb: 3,
                  }}
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6" color="primary">
                      Symptoms & Severity
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      {responses.map((item, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                          <Paper
                            elevation={2}
                            sx={{
                              p: 2,
                              height: "100%",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography
                              variant="subtitle2"
                              sx={{
                                fontWeight: "bold",
                                wordBreak: "break-word",
                              }}
                            >
                              {item.questionnaries_item_name}
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ mt: 1 }}
                              color="text.secondary"
                            >
                              Severity: {item.questionnaries_values * 10}%
                            </Typography>
                          </Paper>
                        </Grid>
                      ))}
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              )}
              <PrescriptionDetailsCustomer
                item_id={selectedPainArea?.item_id}
                customer_id={selectedUserId}
                diagnosis_id={selectedPainArea?.diagnosis_id}
                sx={{ mt: 5 }}
                onSuccess={handleReset}
              />
            </Box>
          </motion.div>
        </>
      )}

      <PrescriptionTable prescriptions={prescriptions} loading={loading} />
    </>
  );
};

export default Prescriptions;
